module.exports = __webpack_public_path__ + "static/media/configurator-reno_elements.ff4282e3.png";